import ScalarSidebarLoading_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarLoading.vue.script.js";
/* empty css                                   */
//#region src/components/ScalarSidebar/ScalarSidebarLoading.vue
var ScalarSidebarLoading_default = ScalarSidebarLoading_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarLoading_default as default };

//# sourceMappingURL=ScalarSidebarLoading.vue.js.map